import { getCarDetailsForm } from '../../../selectors/ugMotorInsurance/carDetails';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import {
    getCustomerIdValue,
    getInsuranceQuotationIdValue,
    getVehicleRecordIdValue,
} from '../../../selectors/ugMotorInsurance/quote';
import { setShowTaggingErrorModal, setTaggingErrorMessage } from '../../../actions/ugMotorInsurance/quote';
import { setCarDetailsSubmittedValue, setSelectedFormValue } from '../../../actions/ugMotorInsurance/carDetails';
import { navigateToCarDetails } from '../../../actions/ugMotorInsurance/routing';

export const submitVehicleDetailsService = async (store, next, action) => {
    const state = store.getState();

    if (getIsApiPending(state)) {
        return next(action);
    }

    store.dispatch(setShowTaggingErrorModal(false));
    store.dispatch(setTaggingErrorMessage(null));
    store.dispatch(apiTransitionPayloadCollection.pending());

    try {
        await makeSubmission(store.getState());

        store.dispatch(setCarDetailsSubmittedValue(true));

        store.dispatch(navigateToCarDetails());
        store.dispatch(setSelectedFormValue('documents'));
    } catch (error) {
        store.dispatch(setCarDetailsSubmittedValue(false));
        const status = error?.response?.status;

        if (status === 401) {
            store.dispatch(collectLoginDetails());
        }

        store.dispatch(setTaggingErrorMessage('Something went wrong. Try again later'));
        store.dispatch(setShowTaggingErrorModal(true));
    } finally {
        store.dispatch(apiTransitionPayloadCollection.initial());
    }

    return next(action);
};

const payloadCollection = (state) => {
    const carDetails = getCarDetailsForm(state);

    const customerId = getCustomerIdValue(state);
    const vehicleRecordId = getVehicleRecordIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    const carDetailsPayload = {
        customerId: customerId.value,
        quotationId: insuranceQuotationId.value,
        vehicleId: vehicleRecordId.value,
        registrationNumber: carDetails.registrationNumber.value,
        chassisNumber: carDetails.chasisNumber.value,
        manufacturerModel: carDetails.manufacturerModel?.value || 'N/A',
        fuel: carDetails.fuel.value,
        bodyType: carDetails.bodyType.value,
        threeYearsWithLicense: carDetails.threeYearsWithLicense.value === 'true',
        //yearsWithLicense: carDetails.yearsWithLicense.value ? parseInt(carDetails.yearsWithLicense.value) : 0,
        sittingCapacity: carDetails.sittingCapacity.value ? parseInt(carDetails.sittingCapacity.value) : 0,
        color: carDetails.color.value,
    };

    return {
        ...carDetailsPayload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/submit/vehicle-details';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
